import axios from 'axios'
import { DOCUMENTS } from 'constants/docUploadConstant'
import { useDynamicManageStore } from 'store/useDynamicManageStore'

export const axiosClient = axios.create({
    baseURL: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_PDS_API : process.env.APP_URL
})

axiosClient.interceptors.request.use(
    (config) => {
        config.headers = {
            Accept: config.headers.Accept,
            'Content-Encoding': config.headers['Content-Encoding'],
            'Content-Length': config.headers['Content-Length'],
            'Content-Type': config.headers['Content-Type'],
            'User-Agent': config.headers['User-Agent'],
            Authorization: useDynamicManageStore.getState().authToken,
            'x-fmcc-order-id': useDynamicManageStore.getState().orderId,
            rxvt: useDynamicManageStore.getState().rxvt
        }

        config.params = {
            ...config.params,
            timestamp: new Date().toISOString()
        }
        return config
    },
    (err) => {
        return Promise.reject(err)
    }
)

axiosClient.interceptors.response.use(
    (response) => {
        if (
            response &&
            response.data &&
            response.data.transactionType === 'Lease' &&
            response.data?.vehicleFinancing?.lender !== 'Ford Motor Credit Company'
        ) {
            return Promise.reject('Non-FMCC Leases')
        }
        return response
    },
    (err) => {
        if (err?.config?.method === 'post' && err?.config?.url?.endsWith(`/${DOCUMENTS}`)) {
            return err.response
        }
        return Promise.reject(err)
    }
)
